import { React, useState, useEffect, useContext, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Row, Col, Tooltip, Form, Select, Button, Alert, Radio, InputNumber, Input as AntInput } from 'antd';
import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { SelectOption } from '@iso/components/uielements/select';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentHolder from '@iso/components/utility/contentHolder';
import parse from "html-react-parser";
import api from '../../../api';
import { AppContext } from '../../../context/ContextProvider';
import { AlertContext } from '../../../context/alertContext';
import customScriptIcon from '@iso/assets/images/custom-script-icon.svg';
import blueTriangleWorkflow from '@iso/assets/images/blueTriangleWorkflow.svg';
import dragIcon from '@iso/assets/images/drag-icon.svg';
import awsLogo from '../../../assets/images/aws.svg';
import { marketplaceStatuses, timeSince } from '../../../context/helper';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../Widgets/SmallCards/SmallCards.styles';
import plusIcon from '@iso/assets/images/plusIcon.svg';
import ScrollableFeed from 'react-scrollable-feed';
import CodeViewGeneral from '../../Clusters/Task/CodeViewGeneral';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import Input from '@iso/containers/Deployments/ApplicationBasicDetails.styles';
import SelectStyled from '@iso/containers/Deployments/Deployment.styles';
import Scrollbars from 'react-custom-scrollbars-2';

const { Option } = Select;

let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let innerSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9B9B9B",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
}

const blueTriangleStyle = {
    position: "absolute",
    right: "2.5%",
    top: "40%",
}

const widgetStyle = {
    marginTop: "20px",
    width: "100%",
};

let inputStyle = {
    padding: '4px 11px',
    color: 'rgba(0, 0, 0, 0.88)',
    fontSize: '14px',
    borderRadius: '6px',
    height: "44px"
};

const boxStyle = {
    width: "100%",
    marginTop: "0",
    border: "0",
    padding: "0",
    height: "fit-content"
};

let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

// Key used for debugging logs so they can be filtered easily in browser console
const LOG_KEY = "migration-script-console";
// helper logger
const log = (...args) => console.log(`[${LOG_KEY}]`, ...args);

export default ({
    data,
    openDrawer = true,
    columnId,
    ind,
    workflowNodeData,
    workflowEdgesData,
}) => {
    console.log("[POST-DEPLOY] === POST DEPLOY CUSTOM SCRIPT DRAWER OPENED ===");
    console.log("[POST-DEPLOY] Props received - data:", data);
    console.log("[POST-DEPLOY] Props received - ind:", ind);
    console.log("[POST-DEPLOY] Props received - columnId:", columnId);

    const { openRightDrawer, setOpenRightDrawer, workflowData, setWorkflowData, currentWorkflowData, setCurrentWorkflowData, setWorkflowNodeData, setWorkflowEdgesData, workflowTypeExecution, setWorkflowTypeExecution } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    // const navigate = useNavigate();
    // const location = useLocation();
    const [form] = Form.useForm();

    console.log("[POST-DEPLOY] Context - workflowNodeData length:", workflowNodeData?.length);
    console.log("[POST-DEPLOY] Context - workflowEdgesData length:", workflowEdgesData?.length);
    console.log("[POST-DEPLOY] Context - currentWorkflowData.deployConfig:", currentWorkflowData?.deployConfig);

    // Derive a safe environment index
    const envIndex = ind !== undefined && ind !== null ? ind : (data?.indx ?? 0);

    // Debug log the envIndex calculation
    console.log("[POST-DEPLOY] envIndex calculation:");
    console.log("[POST-DEPLOY] ind prop:", ind);
    console.log("[POST-DEPLOY] data?.indx:", data?.indx);
    console.log("[POST-DEPLOY] final envIndex:", envIndex);

    const [isSaving, setIsSaving] = useState(false);
    const [hasUserEdited, setHasUserEdited] = useState(false);
    const [localChanges, setLocalChanges] = useState(null); // Store local changes until main save
    const [error, setError] = useState(false);
    // const [fetching, setFetching] = useState(false);

    // Refs for scrolling
    const formScrollContainerRef = useRef(null);
    const scriptSectionRef = useRef(null);

    const scrollElementIntoView = (element, offset = 30) => {
        if (!element) return;

        const container = formScrollContainerRef.current;
        if (container) {
            const elementRect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const targetTop = container.scrollTop + (elementRect.top - containerRect.top) - offset;

            container.scrollTo({
                top: targetTop < 0 ? 0 : targetTop,
                behavior: 'smooth',
            });
        } else {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Consolidated post-deploy custom script data state
    const [postDeployCustomScript, setPostDeployCustomScript] = useState({
        script: "",
        containerType: "application",
        customImage: "",
        triggerMode: 'ready',
        readyStrategy: 'k8s',
        timeoutSeconds: 600,
        pollSeconds: 5,
        delaySeconds: 60,
        healthUrl: ''
    });

    // Add a debug useEffect to monitor script state changes
    useEffect(() => {
        log("Script state changed to:", postDeployCustomScript.script);
        log("Script length:", postDeployCustomScript.script?.length);
        if (postDeployCustomScript.script) {
            log("First 100 chars:", postDeployCustomScript.script.substring(0, 100));
        }
    }, [postDeployCustomScript.script]);

    // Migration templates
    const migrationTemplates = {
        django: `#!/bin/bash
            # Django Migration Script
            echo "Running Django migrations..."
            python manage.py migrate --noinput
            python manage.py collectstatic --noinput
            echo "Migrations completed successfully"`,
        rails: `#!/bin/bash
            # Rails Migration Script
            echo "Running Rails migrations..."
            bundle exec rails db:migrate
            bundle exec rails assets:precompile
            echo "Migrations completed successfully"`,
        nodejs: `#!/bin/bash
            # Node.js Migration Script
            echo "Running Node.js migrations..."
            npm run migrate
            # npm run seed  # Uncomment if needed
            echo "Migrations completed successfully"`,
        custom: ""
    };

    useEffect(() => {
        if (currentWorkflowData?.deployConfig?.config?.environments?.[0]?.tools?.post_deploy_script?.config) {
            let tempData = currentWorkflowData.deployConfig.config.environments[0].tools.post_deploy_script.config;
            setPostDeployCustomScript({
                script: tempData.script || "",
                containerType: tempData.containerType || "application",
                customImage: tempData.customImage || "",
                triggerMode: tempData.triggerMode || 'ready',
                readyStrategy: tempData.ready?.strategy || 'k8s',
                timeoutSeconds: tempData.ready?.timeoutSeconds || 600,
                pollSeconds: tempData.ready?.pollSeconds || 5,
                delaySeconds: tempData.delaySeconds || 60,
                healthUrl: tempData.healthUrl || ''
            });

            form.setFieldsValue({
                script: tempData.script || "",
                containerType: tempData.containerType || "application",
                customImage: tempData.customImage || "",
                triggerMode: tempData.triggerMode || 'ready',
                readyStrategy: tempData.ready?.strategy || 'k8s',
                timeoutSeconds: tempData.ready?.timeoutSeconds || 600,
                pollSeconds: tempData.ready?.pollSeconds || 5,
                delaySeconds: tempData.delaySeconds || 60,
                healthUrl: tempData.healthUrl || ''
            });
        }
        else{
            form.setFieldsValue({...postDeployCustomScript});
        }
    }, [])

    // useEffect(() => {
    //     // Don't reload data if we're currently saving or if user has edited the script
    //     if (isSaving || hasUserEdited) {
    //         log("Skipping data reload - currently saving or user has edited");
    //         return;
    //     }

    //     // If we have local changes, use them instead of backend data
    //     if (localChanges) {
    //         log("Using local changes instead of backend data:", localChanges);
    //         const ct = localChanges.containerType || localChanges.containertype || localChanges.container_type || "application";
    //         const ci = localChanges.customImage || localChanges.customimage || localChanges.custom_image || "";
    //         const scr = localChanges.script || "";
    //         log("Setting script state from local changes:", scr);
    //         setPostDeployCustomScript({
    //             ...postDeployCustomScript,
    //             script: scr,
    //             containerType: ct,
    //             customImage: ci
    //         });
    //         return;
    //     }

    //     log("=== LOAD EXISTING CONFIG ===");
    //     log("envIndex:", envIndex);
    //     log("currentWorkflowData:", currentWorkflowData);
    //     log("currentWorkflowData.steps:", currentWorkflowData?.steps);

    //     // Try to get the most up-to-date data from localStorage first
    //     let deployCfg = currentWorkflowData?.deployConfig || {};
    //     let stepsData = currentWorkflowData?.steps;

    //     // Check localStorage for more recent data
    //     const localStorageWorkflow = localStorage.getItem("Workflow");
    //     if (localStorageWorkflow) {
    //         try {
    //             const parsedWorkflow = JSON.parse(localStorageWorkflow);
    //             log("DEBUG LOAD: localStorage workflow deployConfig.postDeployScripts:", parsedWorkflow.deployConfig?.postDeployScripts);

    //             if (parsedWorkflow.deployConfig?.postDeployScripts) {
    //                 log("DEBUG LOAD: Using localStorage deployConfig.postDeployScripts");
    //                 deployCfg = parsedWorkflow.deployConfig;
    //                 stepsData = parsedWorkflow.steps;
    //             }
    //         } catch (e) {
    //             log("DEBUG LOAD: Error parsing localStorage workflow:", e);
    //         }
    //     }

    //     // === BEGIN NEW UNIFIED CONFIG LOAD ===
    //     let config;   // <-- ensure declared before use to satisfy linter
    //     // Build a list of possible sources in priority order and pick the first
    //     const configSources = [];

    //     // 1) Local changes captured in drawer (unsaved yet)
    //     if (localChanges) configSources.push({ src: "localChanges", cfg: localChanges });

    //     // 2) postDeployScripts exact key (number or string)
    //     if (deployCfg.postDeployScripts) {
    //         configSources.push({ src: `postDeployScripts[${envIndex}]`, cfg: deployCfg.postDeployScripts[envIndex] });
    //         configSources.push({ src: `postDeployScripts['${String(envIndex)}']`, cfg: deployCfg.postDeployScripts[String(envIndex)] });
    //     }

    //     // 3) steps[].config
    //     if (Array.isArray(stepsData)) {
    //         const step = stepsData.find(s => s?.name === "post_deploy");
    //         if (step?.config) configSources.push({ src: "steps[post_deploy].config", cfg: step.config });
    //     }

    //     // 4) postDeployConfig.config
    //     if (currentWorkflowData?.postDeployConfig?.config) {
    //         configSources.push({ src: "postDeployConfig.config", cfg: currentWorkflowData.postDeployConfig.config });
    //     }

    //     // 5) Legacy deployCfg.tools
    //     if (Array.isArray(deployCfg.tools) && deployCfg.tools[envIndex]?.postDeployScript) {
    //         configSources.push({ src: "deployCfg.tools[envIndex].postDeployScript", cfg: deployCfg.tools[envIndex].postDeployScript });
    //     }

    //     // 6) First entry in postDeployScripts (single-env fallback)
    //     if (deployCfg.postDeployScripts && Object.keys(deployCfg.postDeployScripts).length) {
    //         const firstKey = Object.keys(deployCfg.postDeployScripts)[0];
    //         configSources.push({ src: `postDeployScripts[${firstKey}]`, cfg: deployCfg.postDeployScripts[firstKey] });
    //     }

    //     // Pick first non-null cfg having at least script or triggerMode
    //     config = undefined;
    //     for (const { src, cfg } of configSources) {
    //         if (cfg && (cfg.script || cfg.triggerMode)) { config = cfg; log("[RUNWHEN-LOAD] picked config from", src, cfg); break; }
    //     }
    //     // === END NEW UNIFIED CONFIG LOAD ===

    //     if (config) {
    //         log("Final config found:", config);
    //         log("Script value from config:", config.script);
    //         const ct = config.containerType || config.containertype || config.container_type || "application";
    //         const ci = config.customImage || config.customimage || config.custom_image || "";
    //         const scr = config.script || "";
    //         const rc = config.ready || {};

    //         log("Setting script state to:", scr);
    //         log("Script length:", scr.length);
    //         log("First 50 chars of script:", scr.substring(0, 50));
    //         log("[RUNWHEN-LOAD] Loaded config.triggerMode:", config.triggerMode);

    //         const loadedData = {
    //             script: scr,
    //             containerType: ct,
    //             customImage: ci,
    //             triggerMode: config.triggerMode || 'ready',
    //             readyStrategy: rc.strategy || 'k8s',
    //             timeoutSeconds: Number(rc.timeoutSeconds || (rc.strategy === 'http' ? 300 : 600)),
    //             pollSeconds: Number(rc.pollSeconds || 5),
    //             delaySeconds: Number(config.delaySeconds || 60),
    //             healthUrl: rc.url || ''
    //         };

    //         // Set state
    //         setPostDeployCustomScript(loadedData);

    //         // Set form values
    //         form.setFieldsValue(loadedData);
    //     } else {
    //         log("No existing post-deploy config found for this env");
    //         const defaultData = {
    //             script: "",
    //             containerType: "application",
    //             customImage: "",
    //             triggerMode: 'ready',
    //             readyStrategy: 'k8s',
    //             timeoutSeconds: 600,
    //             pollSeconds: 5,
    //             delaySeconds: 60,
    //             healthUrl: ''
    //         };

    //         // Set state
    //         setPostDeployCustomScript(defaultData);

    //         // Set default form values
    //         form.setFieldsValue(defaultData);
    //     }
    // }, [currentWorkflowData, envIndex, isSaving, hasUserEdited, localChanges]);

    const handelCancel = () => {
        setIsSaving(false); // Reset saving flag when cancelling
        setHasUserEdited(false); // Reset edit flag when cancelling
        setLocalChanges(null); // Clear local changes when cancelling
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    // Function to clear local changes (can be called from parent when main workflow is saved)
    const clearLocalChanges = () => {
        log("Clearing local changes - main workflow saved");
        setLocalChanges(null);
        setHasUserEdited(false);
    }

    // Expose clearLocalChanges function to parent component
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.clearPostDeployLocalChanges = clearLocalChanges;
        }
    }, []);

    // Add a cleanup effect that runs periodically to remove any duplicate nodes
    useEffect(() => {
        const cleanupDuplicates = () => {
            // Use the same detection logic as in save
            const allPostDeployNodes = workflowNodeData.filter(node => {
                return node.data?.label === "post_deploy_script" ||
                    node.data?.label === "post_deploy" ||
                    (node.type === "customToolNode" && node.data?.type === "postDeployScript");
            });

            const nodesByEnv = {};

            // Group nodes by environment index
            allPostDeployNodes.forEach(node => {
                const envIdx = String(node.data?.indx || "0");
                if (!nodesByEnv[envIdx]) {
                    nodesByEnv[envIdx] = [];
                }
                nodesByEnv[envIdx].push(node);
            });

            // Check if any environment has duplicates
            let hasDuplicates = false;
            Object.keys(nodesByEnv).forEach(envIdx => {
                if (nodesByEnv[envIdx].length > 1) {
                    hasDuplicates = true;
                    console.log(`[CLEANUP] Found ${nodesByEnv[envIdx].length} duplicate post-deploy nodes for env ${envIdx}`);
                }
            });

            if (hasDuplicates) {
                console.log("[CLEANUP] Removing duplicate post-deploy nodes...");
                let cleanedNodes = [...workflowNodeData];
                let cleanedEdges = [...workflowEdgesData];

                Object.keys(nodesByEnv).forEach(envIdx => {
                    if (nodesByEnv[envIdx].length > 1) {
                        // Keep the first node, remove the rest
                        const nodesToRemove = nodesByEnv[envIdx].slice(1);
                        const idsToRemove = nodesToRemove.map(n => n.id);
                        console.log(`[CLEANUP] Removing nodes with IDs: ${idsToRemove.join(', ')}`);

                        cleanedNodes = cleanedNodes.filter(n => !idsToRemove.includes(n.id));
                        cleanedEdges = cleanedEdges.filter(e => !idsToRemove.includes(e.source) && !idsToRemove.includes(e.target));
                    }
                });

                setWorkflowNodeData(cleanedNodes);
                setWorkflowEdgesData(cleanedEdges);
                currentWorkflowData.workflowNodeData = cleanedNodes;
                currentWorkflowData.workflowEdgesData = cleanedEdges;
                setCurrentWorkflowData({ ...currentWorkflowData });
                localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));
                console.log("[CLEANUP] Cleanup complete");
            }
        };

        // Run cleanup after a delay to catch any race conditions
        const timeoutId = setTimeout(cleanupDuplicates, 1000);
        return () => clearTimeout(timeoutId);
    }, [workflowNodeData.length]); // Run when the number of nodes changes

    const handleSaveDetails = async () => {
        log("=== SAVE START ===");
        log("envIndex:", envIndex);
        log("ind prop:", ind);
        log("data.indx:", data?.indx);
        log("Incoming script:", postDeployCustomScript.script);
        log("Script length:", postDeployCustomScript.script?.length);

        // Validate script first (not in form)
        if (!postDeployCustomScript.script || postDeployCustomScript.script.trim() === "") {
            setError(true);
        }

        try {
            // Validate form fields
            const values = await form.validateFields();
            console.log('Form validation success:', values);

            // Set saving flag to prevent useEffect from reloading data
            setIsSaving(true);

            // Check if ind is valid
            if (envIndex === undefined || envIndex === null) {
                log("ERROR: envIndex is undefined or null");
                setIsSaving(false); // Reset saving flag on error
                setHasUserEdited(false); // Reset edit flag on error
                toggleAlert("error", "Error", "Invalid environment index");
                return;
            }
        } catch (err) {
            console.log("Form validation failed:", err);
            setIsSaving(false);

            // Scroll to first error field
            if (err?.errorFields && err.errorFields.length > 0) {
                const firstErrorField = err.errorFields[0];
                const namePath = firstErrorField.name;
                const primaryName = Array.isArray(namePath) ? namePath[0] : namePath;

                console.log("namePath:", namePath);
                console.log("primaryName:", primaryName);
                setTimeout(() => {
                    if (primaryName === 'script') {
                        scrollElementIntoView(scriptSectionRef.current);
                    }
                    else if (primaryName) {
                        form.scrollToField(primaryName, {
                            behavior: 'smooth',
                            block: 'start',
                        });

                        setTimeout(() => {
                            let fieldInstance = null;
                            if (typeof form.getFieldInstance === 'function') {
                                fieldInstance = form.getFieldInstance(primaryName);
                            }

                            if (fieldInstance && typeof fieldInstance.focus === 'function') {
                                fieldInstance.focus();
                            } else {
                                const inputElement = document.querySelector(`[name="${primaryName}"]`) ||
                                    document.querySelector(`[id*="${primaryName}"]`);
                                if (inputElement && typeof inputElement.focus === 'function') {
                                    inputElement.focus();
                                }
                            }
                        }, 200);
                    }
                    else if (primaryName === 'script') {
                        scrollElementIntoView(scriptSectionRef.current);
                    }
                }, 150);
            }

            return;
        }

        // Prepare the configuration object
        const postDeployConfig = {
            enabled: true,
            containerType: postDeployCustomScript.containerType,
            customImage: postDeployCustomScript.containerType === "custom" ? postDeployCustomScript.customImage : null,
            script: postDeployCustomScript.script,
            environment: currentWorkflowData?.deployConfig?.tools?.[envIndex]?.env || null,
            envIndex: envIndex,
            triggerMode: postDeployCustomScript.triggerMode,
            ...(postDeployCustomScript.triggerMode === 'ready' ? {
                ready: {
                    strategy: postDeployCustomScript.readyStrategy,
                    ...(postDeployCustomScript.readyStrategy === 'http' ? { url: postDeployCustomScript.healthUrl } : {}),
                    timeoutSeconds: postDeployCustomScript.timeoutSeconds,
                    pollSeconds: postDeployCustomScript.pollSeconds,
                }
            } : {}),
            ...(postDeployCustomScript.triggerMode === 'delay' ? { delaySeconds: postDeployCustomScript.delaySeconds } : {}),
        };

        log("[RUNWHEN-SAVE] triggerMode saving:", postDeployCustomScript.triggerMode);
        log("[RUNWHEN-SAVE] postDeployConfig:", postDeployConfig);

        // Store local changes (this will be used until main workflow save)
        setLocalChanges(postDeployConfig);

        // Ensure deployConfig structure exists
        if (!currentWorkflowData.deployConfig) {
            log("ERROR: deployConfig is missing");
            setIsSaving(false); // Reset saving flag on error
            setHasUserEdited(false); // Reset edit flag on error
            toggleAlert("error", "Error", "Deploy configuration is missing");
            return;
        }

        if (!currentWorkflowData.deployConfig.tools) {
            log("ERROR: deployConfig.tools is missing");
            setIsSaving(false); // Reset saving flag on error
            setHasUserEdited(false); // Reset edit flag on error
            toggleAlert("error", "Error", "Deploy tools configuration is missing");
            return;
        }

        // ---- Build immutable updates ----
        // log("DEBUG: currentWorkflowData.deployConfig:", currentWorkflowData.deployConfig);
        // log("DEBUG: currentWorkflowData.deployConfig?.postDeployScripts:", currentWorkflowData.deployConfig?.postDeployScripts);
        // log("DEBUG: envIndex:", envIndex);
        // log("DEBUG: postDeployConfig:", postDeployConfig);

        // Ensure envIndex is valid
        if (envIndex === undefined || envIndex === null) {
            log("ERROR: envIndex is undefined/null, cannot save script");
            setIsSaving(false);
            setHasUserEdited(false);
            toggleAlert("error", "Error", "Invalid environment index");
            return;
        }

        // Save to multiple possible keys to ensure the script gets saved
        // const updatedPostDeployScripts = {
        //     ...(currentWorkflowData.deployConfig?.postDeployScripts || {}),
        //     [envIndex]: postDeployConfig,
        //     // Fallback: also save to key "0" in case envIndex is wrong
        //     "0": postDeployConfig,
        // };

        log("DEBUG: Saving script to envIndex:", envIndex);
        log("DEBUG: postDeployConfig being saved:", postDeployConfig);

        // log("DEBUG: updatedPostDeployScripts:", updatedPostDeployScripts);

        // add post_deploy_tool in environments -> tools 
        const updatedEnvironments = currentWorkflowData.deployConfig.config.environments.map((environment, id) => {
            if (id === envIndex) {
                return {
                    ...environment,
                    tools: {...(environment.tools || {}), "post_deploy_script": { name: "post_deploy_script", enabled: true, config: postDeployConfig, tools: {} }}
                };
            }
            return environment;
        });

        const updatedDeployConfig = {
            ...currentWorkflowData.deployConfig,
            config: {
                ...currentWorkflowData.deployConfig.config,
                environments: updatedEnvironments
            }
        };

        // const existingSteps = Array.isArray(currentWorkflowData.steps) ? currentWorkflowData.steps : [];
        // const existingPdIdx = existingSteps.findIndex(s => s?.name === "post_deploy");
        // const updatedSteps = existingPdIdx >= 0
        //     ? existingSteps.map((s, i) => i === existingPdIdx ? { ...s, enabled: true, config: postDeployConfig, tools: [] } : s)
        //     : [...existingSteps, { name: "post_deploy", enabled: true, config: postDeployConfig, tools: [] }];

        const updatedWorkflow = {
            ...currentWorkflowData,
            deployConfig: updatedDeployConfig,
            // postDeployConfig: { name: "post_deploy", enabled: true, config: postDeployConfig, tools: [] },
            // steps: updatedSteps,
        };

        log("DEBUG: updatedDeployConfig:", updatedDeployConfig);
        // log("DEBUG: updatedDeployConfig.postDeployScripts:", updatedDeployConfig.postDeployScripts);
        // log("DEBUG: Script content in postDeployScripts:", updatedDeployConfig.postDeployScripts[envIndex]?.script);
        // log("DEBUG: Script length:", updatedDeployConfig.postDeployScripts[envIndex]?.script?.length);
        // log("UpdatedWorkflow.postDeployConfig.config.script:", updatedWorkflow.postDeployConfig?.config?.script);
        // log("UpdatedWorkflow.steps[post_deploy]:", updatedWorkflow.steps.find(s => s.name === "post_deploy"));

        // Update contexts immutably
        log("DEBUG: About to update currentWorkflowData with:", updatedWorkflow);
        // log("DEBUG: updatedWorkflow.deployConfig.postDeployScripts:", updatedWorkflow.deployConfig.postDeployScripts);

        // Persist to context and localStorage without clobbering workflowData tools state
        setCurrentWorkflowData(updatedWorkflow);
        localStorage.setItem("Workflow", JSON.stringify(updatedWorkflow));
        // Also persist a dedicated cache to avoid other flows overwriting nested keys
        // try {
        //     localStorage.setItem("PostDeployScripts", JSON.stringify(updatedPostDeployScripts));
        // } catch (e) { /* noop */ }

        // log("DEBUG: After updating, currentWorkflowData.deployConfig.postDeployScripts:", updatedWorkflow.deployConfig.postDeployScripts);

        // Verify what was saved to localStorage
        // const savedWorkflow = JSON.parse(localStorage.getItem("Workflow"));
        // log("DEBUG: Saved to localStorage - deployConfig.postDeployScripts:", savedWorkflow?.deployConfig?.postDeployScripts);
        // log("DEBUG: Saved script content:", savedWorkflow?.deployConfig?.postDeployScripts?.[envIndex]?.script);

        // log("Updated workflow data saved to localStorage");

        // Add post-deploy script as a new node after deploy with a small delay
        // Check if node already exists before adding
        // Also check localStorage to avoid race conditions

        // First, log ALL nodes to understand the structure
        log(`[DEDUP-CHECK] === Starting duplicate check for envIndex ${envIndex} ===`);
        // log(`[DEDUP-CHECK] All nodes in workflowNodeData:`, workflowNodeData.map(node => ({
        //     id: node.id,
        //     type: node.type,
        //     label: node.data?.label,
        //     indx: node.data?.indx,
        //     data: node.data
        // })));

        // Check for post_deploy_script nodes with multiple possible label formats
        // let existingPostDeployNodes = workflowNodeData.filter(node => {
        //     const isPostDeploy = node.data?.label === "post_deploy_script" ||
        //         node.data?.label === "post_deploy" ||
        //         node.type === "customToolNode" && node.data?.type === "postDeployScript";

        //     // Handle undefined/null indx - default to 0 for single env scenarios
        //     const nodeEnvIndex = node.data?.indx !== undefined && node.data?.indx !== null ? Number(node.data.indx) : 0;
        //     const targetEnvIndex = envIndex !== undefined && envIndex !== null ? Number(envIndex) : 0;
        //     const matchesEnv = nodeEnvIndex === targetEnvIndex;

        //     if (node.data?.label?.includes("post") || node.data?.type?.includes("post")) {
        //         log(`[DEDUP-CHECK] Checking node ${node.id}: isPostDeploy=${isPostDeploy}, matchesEnv=${matchesEnv}, nodeEnvIndex=${nodeEnvIndex}, targetEnvIndex=${targetEnvIndex}, raw indx=${node.data?.indx}`);
        //     }

        //     return isPostDeploy && matchesEnv;
        // });

        // log(`[DEDUP-CHECK] Current workflowNodeData length: ${workflowNodeData.length}`);
        // log(`[DEDUP-CHECK] Found ${existingPostDeployNodes.length} existing post-deploy nodes for env ${envIndex}`);

        // // Double-check localStorage in case state hasn't updated yet
        // try {
        //     const storedWorkflow = JSON.parse(localStorage.getItem("Workflow") || "{}");
        //     const storedNodes = storedWorkflow.workflowNodeData || [];

        //     log(`[DEDUP-CHECK] localStorage nodes:`, storedNodes.map(node => ({
        //         id: node.id,
        //         type: node.type,
        //         label: node.data?.label,
        //         indx: node.data?.indx
        //     })));

        //     const storedPostDeployNodes = storedNodes.filter(node => {
        //         const isPostDeploy = node.data?.label === "post_deploy_script" ||
        //             node.data?.label === "post_deploy" ||
        //             node.type === "customToolNode" && node.data?.type === "postDeployScript";

        //         // Handle undefined/null indx - default to 0
        //         const nodeEnvIndex = node.data?.indx !== undefined && node.data?.indx !== null ? Number(node.data.indx) : 0;
        //         const targetEnvIndex = envIndex !== undefined && envIndex !== null ? Number(envIndex) : 0;
        //         const matchesEnv = nodeEnvIndex === targetEnvIndex;

        //         return isPostDeploy && matchesEnv;
        //     });

        //     log(`[DEDUP-CHECK] localStorage has ${storedPostDeployNodes.length} post-deploy nodes for env ${envIndex}`);

        //     // If localStorage has nodes but state doesn't, use localStorage as truth
        //     if (storedPostDeployNodes.length > 0 && existingPostDeployNodes.length === 0) {
        //         log(`[DEDUP-CHECK] WARNING: State out of sync with localStorage, using localStorage as truth`);
        //         existingPostDeployNodes = storedPostDeployNodes;
        //     }
        // } catch (e) {
        //     log(`[DEDUP-CHECK] Error checking localStorage:`, e);
        // }

        // // Add a flag to prevent duplicate node creation
        // const nodeAddKey = `post_deploy_adding_${envIndex}`;
        // const isNodeBeingAdded = window[nodeAddKey];

        // if (isNodeBeingAdded) {
        //     log(`[DEDUP-CHECK] Node creation already in progress for envIndex ${envIndex}, skipping`);
        //     return;
        // }

        // if (existingPostDeployNodes.length === 0) {
        //     log(`[DEDUP-CHECK] No existing post-deploy node found, will add new node`);

        //     // Set flag to prevent duplicate additions
        //     window[nodeAddKey] = true;

        //     setTimeout(() => {
        //         log(`[DEDUP-CHECK] Timeout executed, calling addPostDeployNode for envIndex ${envIndex}`);
        //         try {
        //             addPostDeployNode();
        //         } catch (error) {
        //             log("Error in addPostDeployNode:", error);
        //         } finally {
        //             // Clear the flag after node addition
        //             setTimeout(() => {
        //                 delete window[nodeAddKey];
        //                 log(`[DEDUP-CHECK] Cleared node addition flag for envIndex ${envIndex}`);
        //             }, 500);
        //         }
        //     }, 100);
        // } else {
        //     log(`[DEDUP-CHECK] ${existingPostDeployNodes.length} post-deploy node(s) already exist, updating instead of adding`);

        //     // If multiple nodes exist, deduplicate first
        //     // if (existingPostDeployNodes.length > 1) {
        //     //     log(`[DEDUP-CHECK] WARNING: Found ${existingPostDeployNodes.length} duplicate nodes, deduplicating...`);
        //     //     const nodeToKeep = existingPostDeployNodes[0];
        //     //     const nodesToRemove = existingPostDeployNodes.slice(1);
        //     //     const idsToRemove = nodesToRemove.map(n => n.id);

        //     //     const dedupedNodes = workflowNodeData.filter(n => !idsToRemove.includes(n.id));
        //     //     const dedupedEdges = workflowEdgesData.filter(e => !idsToRemove.includes(e.source) && !idsToRemove.includes(e.target));

        //     //     log(`[DEDUP-CHECK] Removing ${idsToRemove.length} duplicate nodes: ${idsToRemove.join(', ')}`);

        //     //     // Update the remaining node with hasConfig flag
        //     //     const updatedNodes = dedupedNodes.map(node => {
        //     //         if (node.id === nodeToKeep.id) {
        //     //             return {
        //     //                 ...node,
        //     //                 data: { ...node.data, hasConfig: true }
        //     //             };
        //     //         }
        //     //         return node;
        //     //     });

        //     //     setWorkflowNodeData(updatedNodes);
        //     //     setWorkflowEdgesData(dedupedEdges);
        //     //     currentWorkflowData.workflowNodeData = updatedNodes;
        //     //     currentWorkflowData.workflowEdgesData = dedupedEdges;
        //     // } else {
        //     //     // Just update the existing node's hasConfig flag
        //     //     const updatedNodes = workflowNodeData.map(node => {
        //     //         const isPostDeploy = node.data?.label === "post_deploy_script" ||
        //     //             node.data?.label === "post_deploy" ||
        //     //             (node.type === "customToolNode" && node.data?.type === "postDeployScript");
        //     //         const matchesEnv = Number(node.data?.indx) === Number(envIndex);

        //     //         if (isPostDeploy && matchesEnv) {
        //     //             return {
        //     //                 ...node,
        //     //                 data: { ...node.data, hasConfig: true }
        //     //             };
        //     //         }
        //     //         return node;
        //     //     });

        //     //     setWorkflowNodeData(updatedNodes);
        //     //     currentWorkflowData.workflowNodeData = updatedNodes;
        //     // }

        //     setCurrentWorkflowData({ ...currentWorkflowData });
        //     localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));
        // }

        toggleAlert("success", "Success", "Post-deploy script configuration saved");

        // Close drawer after a longer delay to allow node to be added
        setTimeout(() => {
            log("Closing drawer");
            setIsSaving(false); // Reset saving flag
            setHasUserEdited(false); // Reset edit flag after successful save
            handelCancel();
        }, 500);

        log("=== SAVE END ===");
    }

    // const addPostDeployNode = () => {
    //     console.log("[POST-DEPLOY-ADD] === ADD NODE START ===");
    //     console.log("[POST-DEPLOY-ADD] Called at:", new Date().toISOString());
    //     console.log("[POST-DEPLOY-ADD] Stack trace:", new Error().stack);
    //     console.log("[POST-DEPLOY-ADD] envIndex:", envIndex);
    //     console.log("[POST-DEPLOY-ADD] Current workflowNodeData length:", workflowNodeData.length);

    //     // Log all existing post-deploy nodes before any operation
    //     const allPostDeployNodes = workflowNodeData.filter(node => {
    //         return node.data?.label === "post_deploy_script" ||
    //             node.data?.label === "post_deploy" ||
    //             (node.type === "customToolNode" && node.data?.type === "postDeployScript");
    //     });
    //     console.log("[POST-DEPLOY-ADD] All existing post-deploy nodes:", allPostDeployNodes.map(n => ({
    //         id: n.id,
    //         type: n.type,
    //         label: n.data?.label,
    //         indx: n.data?.indx,
    //         envIndex_matches: Number(n.data?.indx) === Number(envIndex)
    //     })));

    //     // Log all deploy nodes
    //     const allDeployNodes = workflowNodeData.filter(node => node.type === "deployNode" || node.type === "deployToolNode");
    //     console.log("[POST-DEPLOY-ADD] All deploy nodes found:", allDeployNodes.map(n => ({
    //         id: n.id,
    //         type: n.type,
    //         indx: n.data?.indx
    //     })));

    //     // Find the deploy node - Look for deployToolNode with matching index first, then fallback to deployNode
    //     let deployNode = workflowNodeData.find(node => node.type === "deployToolNode" && node.data?.indx === envIndex);
    //     if (!deployNode) {
    //         deployNode = workflowNodeData.find(node => node.type === "deployNode");
    //     }

    //     if (!deployNode) {
    //         console.log("[POST-DEPLOY-ADD] ERROR: Deploy node not found for index:", envIndex);
    //         console.log("[POST-DEPLOY-ADD] Available node types:", workflowNodeData.map(n => ({
    //             type: n.type,
    //             label: n.data?.label,
    //             indx: n.data?.indx
    //         })));
    //         return;
    //     }

    //     console.log("[POST-DEPLOY-ADD] Found deploy node:", { id: deployNode.id, type: deployNode.type, indx: deployNode.data?.indx });

    //     // Check if post-deploy node already exists for this environment (normalize index types)
    //     const pdNodes = workflowNodeData.filter(node => {
    //         const isPostDeploy = node.data?.label === "post_deploy_script" ||
    //             node.data?.label === "post_deploy" ||
    //             (node.type === "customToolNode" && node.data?.type === "postDeployScript");

    //         // Handle undefined/null indx - default to 0
    //         const nodeEnvIndex = node.data?.indx !== undefined && node.data?.indx !== null ? Number(node.data.indx) : 0;
    //         const targetEnvIndex = envIndex !== undefined && envIndex !== null ? Number(envIndex) : 0;
    //         const matchesEnv = nodeEnvIndex === targetEnvIndex;

    //         if (isPostDeploy) {
    //             console.log(`[POST-DEPLOY-ADD] Node ${node.id}: nodeEnvIndex=${nodeEnvIndex}, targetEnvIndex=${targetEnvIndex}, matches=${matchesEnv}`);
    //         }

    //         return isPostDeploy && matchesEnv;
    //     });
    //     console.log("[POST-DEPLOY-ADD] Found", pdNodes.length, "existing post-deploy nodes for envIndex", envIndex);
    //     const existingNode = pdNodes[0];

    //     // If more than one exists, dedupe: keep the first and remove extras and their edges
    //     if (pdNodes.length > 1) {
    //         console.log("[POST-DEPLOY-ADD] DEDUPLICATING: Found", pdNodes.length, "nodes, removing duplicates");
    //         const idsToRemove = pdNodes.slice(1).map(n => n.id);
    //         console.log("[POST-DEPLOY-ADD] Removing node IDs:", idsToRemove);
    //         let cleanedNodes = workflowNodeData.filter(n => !idsToRemove.includes(n.id));
    //         let cleanedEdges = workflowEdgesData.filter(e => !idsToRemove.includes(e.source) && !idsToRemove.includes(e.target));
    //         setWorkflowNodeData(cleanedNodes);
    //         setWorkflowEdgesData(cleanedEdges);
    //         currentWorkflowData.workflowNodeData = cleanedNodes;
    //         currentWorkflowData.workflowEdgesData = cleanedEdges;
    //         setCurrentWorkflowData({ ...currentWorkflowData });
    //         localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));
    //         console.log("[POST-DEPLOY-ADD] Deduplication complete, returning without adding new node");
    //         return; // Don't add a new node after deduplication
    //     }

    //     if (!existingNode) {
    //         // Double-check one more time to prevent race conditions
    //         const recheckNodes = workflowNodeData.filter(node => {
    //             const isPostDeploy = node.data?.label === "post_deploy_script" ||
    //                 node.data?.label === "post_deploy" ||
    //                 (node.type === "customToolNode" && node.data?.type === "postDeployScript");

    //             // Handle undefined/null indx - default to 0
    //             const nodeEnvIndex = node.data?.indx !== undefined && node.data?.indx !== null ? Number(node.data.indx) : 0;
    //             const targetEnvIndex = envIndex !== undefined && envIndex !== null ? Number(envIndex) : 0;
    //             const matchesEnv = nodeEnvIndex === targetEnvIndex;

    //             return isPostDeploy && matchesEnv;
    //         });
    //         if (recheckNodes.length > 0) {
    //             console.log("[POST-DEPLOY-ADD] RACE CONDITION DETECTED: Node was added while we were checking");
    //             console.log("[POST-DEPLOY-ADD] Aborting node creation");
    //             return;
    //         }

    //         console.log("[POST-DEPLOY-ADD] No existing post-deploy node found, creating new one");

    //         // Generate new node ID (use the next available number)
    //         const nodeIds = workflowNodeData.map(n => parseInt(n.id) || 0);
    //         console.log("[POST-DEPLOY] A10. Current node IDs:", nodeIds);
    //         const maxId = Math.max(...nodeIds, 0);
    //         const newNodeId = String(maxId + 1);
    //         console.log("[POST-DEPLOY] A11. Generated new node ID:", newNodeId);

    //         // Create new post-deploy node with Deploy-like styling
    //         const newNode = {
    //             id: newNodeId,
    //             type: "customToolNode",
    //             data: {
    //                 label: "post_deploy_script",
    //                 id: parseInt(newNodeId),
    //                 indx: envIndex,
    //                 type: "postDeployScript"
    //             },
    //             position: {
    //                 x: (deployNode.position?.x || 0) + 250,
    //                 y: deployNode.position?.y || 0
    //             },
    //             style: { borderRadius: "12px" },
    //         };

    //         console.log("[POST-DEPLOY] A12. New node object:", newNode);

    //         // Find the edge that currently goes FROM the deploy node
    //         const currentEdgeFromDeploy = workflowEdgesData.find(
    //             edge => edge.source === deployNode.id
    //         );
    //         console.log("[POST-DEPLOY] A13. Current edge from deploy node:", currentEdgeFromDeploy);

    //         // Create edge from deploy to post-deploy
    //         const newEdgeToPostDeploy = {
    //             id: `e${deployNode.id}-${newNodeId}`,
    //             source: deployNode.id,
    //             target: newNodeId,
    //             animated: false,
    //             style: { stroke: "#F7F6FA", strokeWidth: 3 },
    //         };

    //         console.log("[POST-DEPLOY] A14. New edge to post-deploy:", newEdgeToPostDeploy);

    //         // Update nodes and edges
    //         let updatedNodes = [...workflowNodeData, newNode];
    //         let updatedEdges = [...workflowEdgesData];

    //         // If there was an edge from deploy to something else, update it
    //         if (currentEdgeFromDeploy) {
    //             // Remove the old edge
    //             updatedEdges = updatedEdges.filter(e => e.id !== currentEdgeFromDeploy.id);

    //             // Add new edge from post-deploy to the next node
    //             const newEdgeFromPostDeploy = {
    //                 id: `e${newNodeId}-${currentEdgeFromDeploy.target}`,
    //                 source: newNodeId,
    //                 target: currentEdgeFromDeploy.target,
    //                 animated: false,
    //                 style: { stroke: "#F7F6FA", strokeWidth: 3 },
    //             };

    //             updatedEdges.push(newEdgeToPostDeploy);
    //             updatedEdges.push(newEdgeFromPostDeploy);
    //         } else {
    //             // Just add the edge to post-deploy
    //             updatedEdges.push(newEdgeToPostDeploy);
    //         }

    //         console.log("[POST-DEPLOY] A15. Before state update - nodes length:", updatedNodes.length);
    //         console.log("[POST-DEPLOY] A16. Before state update - edges length:", updatedEdges.length);

    //         // Update the state to trigger React Flow re-render
    //         setWorkflowNodeData(updatedNodes);
    //         setWorkflowEdgesData(updatedEdges);

    //         console.log("[POST-DEPLOY] A17. State updated with setWorkflowNodeData and setWorkflowEdgesData");

    //         // Trigger workflow re-render by updating workflowTypeExecution
    //         setWorkflowTypeExecution(prev => {
    //             console.log("[POST-DEPLOY] A18. Previous workflowTypeExecution:", prev);
    //             const updated = { ...prev, deploy: true };
    //             console.log("[POST-DEPLOY] A19. Updated workflowTypeExecution:", updated);
    //             return updated;
    //         });

    //         // Also update in currentWorkflowData for persistence
    //         currentWorkflowData.workflowNodeData = updatedNodes;
    //         currentWorkflowData.workflowEdgesData = updatedEdges;
    //         setCurrentWorkflowData({ ...currentWorkflowData });
    //         localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));

    //         console.log("[POST-DEPLOY-ADD] Post-deploy node added successfully");
    //         console.log("[POST-DEPLOY-ADD] Final nodes count:", updatedNodes.length);
    //         console.log("[POST-DEPLOY-ADD] Final post-deploy nodes:", updatedNodes.filter(n => n.data?.label === "post_deploy_script").map(n => ({
    //             id: n.id,
    //             indx: n.data?.indx
    //         })));
    //         console.log("[POST-DEPLOY-ADD] === ADD NODE END - NODE CREATED ===");
    //     } else {
    //         console.log("[POST-DEPLOY-ADD] Post-deploy node already exists for envIndex", envIndex, "- NOT adding new node");

    //         // Ensure hasConfig is true on the single existing node
    //         const updatedNodes = workflowNodeData.map(node => {
    //             const isPostDeploy = node.data?.label === "post_deploy_script" ||
    //                 node.data?.label === "post_deploy" ||
    //                 (node.type === "customToolNode" && node.data?.type === "postDeployScript");

    //             // Handle undefined/null indx - default to 0
    //             const nodeEnvIndex = node.data?.indx !== undefined && node.data?.indx !== null ? Number(node.data.indx) : 0;
    //             const targetEnvIndex = envIndex !== undefined && envIndex !== null ? Number(envIndex) : 0;
    //             const matchesEnv = nodeEnvIndex === targetEnvIndex;

    //             if (isPostDeploy && matchesEnv) {
    //                 return {
    //                     ...node,
    //                     data: { ...node.data, hasConfig: true }
    //                 };
    //             }
    //             return node;
    //         });

    //         // Ensure there is an edge from deploy -> existing post-deploy; if not, rewire
    //         const existingEdgeToPd = workflowEdgesData.find(e => e.source === deployNode.id && e.target === existingNode.id);
    //         let newEdges = [...workflowEdgesData];
    //         if (!existingEdgeToPd) {
    //             const currentEdgeFromDeploy = workflowEdgesData.find(e => e.source === deployNode.id);
    //             if (currentEdgeFromDeploy) {
    //                 // Remove old edge and insert through post-deploy
    //                 newEdges = newEdges.filter(e => e.id !== currentEdgeFromDeploy.id);
    //                 newEdges.push({ id: `e${deployNode.id}-${existingNode.id}`, source: deployNode.id, target: existingNode.id, animated: false, style: { stroke: "#F7F6FA", strokeWidth: 3 } });
    //                 newEdges.push({ id: `e${existingNode.id}-${currentEdgeFromDeploy.target}`, source: existingNode.id, target: currentEdgeFromDeploy.target, animated: false, style: { stroke: "#F7F6FA", strokeWidth: 3 } });
    //             } else {
    //                 // Just connect deploy -> post-deploy
    //                 newEdges.push({ id: `e${deployNode.id}-${existingNode.id}`, source: deployNode.id, target: existingNode.id, animated: false, style: { stroke: "#F7F6FA", strokeWidth: 3 } });
    //             }
    //         }

    //         setWorkflowNodeData(updatedNodes);
    //         setWorkflowEdgesData(newEdges);
    //         setWorkflowTypeExecution(prev => ({ ...prev, deploy: true }));

    //         currentWorkflowData.workflowNodeData = updatedNodes;
    //         currentWorkflowData.workflowEdgesData = newEdges;
    //         setCurrentWorkflowData({ ...currentWorkflowData });
    //         localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));
    //     }

    //     // Final safeguard: ensure only one post_deploy_script exists for this env index
    //     try {
    //         const cleanedNodes = (prev => {
    //             const byEnv = {};
    //             const nodes = [...(prev || workflowNodeData)];
    //             const edges = [...workflowEdgesData];
    //             // Group post-deploy nodes by env index
    //             nodes.forEach(n => {
    //                 if (n.data?.label === 'post_deploy_script') {
    //                     const key = String(n.data?.indx);
    //                     byEnv[key] = byEnv[key] || [];
    //                     byEnv[key].push(n);
    //                 }
    //             });
    //             const key = String(envIndex);
    //             if (byEnv[key] && byEnv[key].length > 1) {
    //                 const keep = byEnv[key][0];
    //                 const removeIds = new Set(byEnv[key].slice(1).map(n => n.id));
    //                 const nn = nodes.filter(n => !removeIds.has(n.id));
    //                 const ee = edges.filter(e => !removeIds.has(e.source) && !removeIds.has(e.target));
    //                 setWorkflowNodeData(nn);
    //                 setWorkflowEdgesData(ee);
    //                 currentWorkflowData.workflowNodeData = nn;
    //                 currentWorkflowData.workflowEdgesData = ee;
    //                 setCurrentWorkflowData({ ...currentWorkflowData });
    //                 localStorage.setItem('Workflow', JSON.stringify({ ...currentWorkflowData }));
    //             }
    //         });
    //         cleanedNodes();
    //     } catch (e) { /* noop */ }
    // }

    const handleContainerChange = (value) => {
        setPostDeployCustomScript({ ...postDeployCustomScript, containerType: value });
        form.setFieldsValue({ containerType: value });

        // If switching to application container, set a default migration script
        if (value === "application" && !postDeployCustomScript.script) {
            setPostDeployCustomScript(prev => ({ ...prev, script: migrationTemplates.django }));
            form.setFieldsValue({ script: migrationTemplates.django });
        }

        // If switching away from custom, clear validation for customImage
        if (value !== "custom") {
            form.setFieldsValue({ customImage: "" });
            setPostDeployCustomScript(prev => ({ ...prev, customImage: "" }));
        }
    }

    const toggleAlert = (type, message, description) => {
        set_alertOptions({
            status: true,
            type: type,
            message: message,
            description: description,
        });
        setTimeout(() => {
            set_alertOptions({
                status: false,
                type: type,
                message: message,
                description: description,
            });
        }, 5000);
    }

    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0", height: "100%" }}>
            <CreateTaskHeader buttonContent="Post Deploy Custom Script" onCancel={handelCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />

            {/* left info section */}
            <Col lg={8} md={8} sm={8} xs={8} style={{ borderRight: "1px solid #ebebeb", height: "calc(100vh - 84px)", overflowY: "auto", overflowX: "hidden" }}>
                <Box
                    title="Configure tools for pipeline"
                    subtitle="Configure post-deployment migration or custom script"
                    titleStyle={{ ...innerTitleStyle, lineHeight: "20px" }}
                    subTitleStyle={innerSubtitleStyle}
                    style={{ border: 0, padding: "0px 20px", margin: 0, marginTop: "40px", height: "fit-content" }}
                />

                <div style={{ position: "relative" }}>
                    <StickerWidgetWrapper className="isoStickerWidget" style={{ marginTop: "16px", marginLeft: "22px", width: "250px", position: "relative" }}>
                        <Box style={{ borderRadius: "10px", cursor: "pointer", padding: "0", position: "relative" }}>
                            <ContentHolder
                                style={{ display: "flex", alignItems: "start", cursor: "pointer", marginTop: "0", position: "relative", padding: "18px" }}
                            >
                                <Box
                                    title={
                                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center", position: "relative", paddingRight: "55px" }}>
                                            <span style={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", width: "36px", height: "36px", background: "white", padding: "3px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.25)" }}>
                                                <img src={customScriptIcon} />
                                            </span>
                                            <div>
                                                <p style={{ color: "#1F1F1F", marginLeft: "10px", fontSize: "12px", lineHeight: "20px", fontFamily: "Poppins" }}>Migration/Script</p>
                                                <p style={{ marginLeft: "10px", ...innerSubtitleStyle }}>Post-deployment</p>
                                            </div>
                                        </div>
                                    }
                                    style={{ border: "transparent", padding: "0", marginBottom: "0", position: "relative" }}
                                    titleStyle={{ ...innerTitleStyle, marginBottom: "0", position: "relative" }}
                                    subTitleStyle={innerSubtitleStyle}
                                />
                            </ContentHolder>
                        </Box>
                    </StickerWidgetWrapper>
                    <img src={blueTriangleWorkflow} style={blueTriangleStyle} />
                </div>
            </Col>

            {/* form section */}
            <Col lg={16} md={16} sm={16} xs={16} style={{ padding: "0" }}>
                <div
                    ref={formScrollContainerRef}
                    style={{ height: "calc(100vh - 84px)", overflowY: "auto", overflowX: "hidden", padding: "0 20px" }}
                >
                    {console.log("postDeployCustomScript in html :", postDeployCustomScript)}
                    <StickerWidgetWrapper className="isoStickerWidget" style={{ marginTop: "20px", width: "100%" }}>
                        <Form
                            form={form}
                            initialValues={postDeployCustomScript}
                            preserve={false}
                            name="post_deploy_script_form"
                            style={{
                                width: "100%",
                                maxWidth: "100%",
                                overflow: "hidden"
                            }}
                            disabled={currentWorkflowData.fromPipeline ? true : false}
                        >
                            <Box
                                title={"Container Type*"}
                                subtitle={"Select the container image for script execution"}
                                titleStyle={boxTitleStyle}
                                subTitleStyle={boxSubtitleStyle}
                                style={{ ...boxStyle }}
                            >
                                <Select
                                    className="customSelectDataSource"
                                    value={postDeployCustomScript.containerType}
                                    onChange={handleContainerChange}
                                    style={{ width: "100%" }}
                                    data-testid="workflow-tool-post-deploy-migration-script-container-type-select"
                                >
                                    <Option value="application">Application Container (Use deployed image)</Option>
                                    <Option value="ubuntu">Ubuntu 22.04</Option>
                                    <Option value="alpine">Alpine Linux</Option>
                                    <Option value="python">Python 3.9</Option>
                                    <Option value="node">Node.js 18</Option>
                                    <Option value="custom">Custom Image</Option>
                                </Select>
                            </Box>

                            {postDeployCustomScript.containerType === "custom" && (
                                <Box
                                    title={"Custom Image Name*"}
                                    subtitle={"Provide public custom docker image. Private images are not supported yet."}
                                    titleStyle={boxTitleStyle}
                                    subTitleStyle={boxSubtitleStyle}
                                    style={{ ...boxStyle }}
                                >
                                    <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                                        <Form.Item
                                            name="customImage"
                                            rules={[
                                                {
                                                    required: postDeployCustomScript.containerType === "custom",
                                                    message: 'Please provide custom image name.',
                                                },
                                                {
                                                    pattern: /^(?:(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}(?::[0-9]+)?\/)?[a-z0-9](?:[a-z0-9._-]{0,255}[a-z0-9])?(?::[a-zA-Z0-9._-]+)?(?:@[a-zA-Z0-9:]+)?$/,
                                                    message: 'Invalid Docker image format (e.g., python:3.9-slim, registry.io/image:tag)',
                                                }
                                            ]}
                                        >
                                            <Input
                                                name="customImage"
                                                value={postDeployCustomScript.customImage}
                                                onChange={(e) => {
                                                    setPostDeployCustomScript({ ...postDeployCustomScript, customImage: e.target.value });
                                                    form.setFieldsValue({ customImage: e.target.value });
                                                }}
                                                placeholder="e.g., python:3.9-slim, node:18-alpine"
                                                style={inputStyle}
                                                data-testid="workflow-tool-post-deploy-migration-script-custom-image-input"
                                            />
                                        </Form.Item>
                                    </ContentHolder>
                                </Box>
                            )}

                            {/* {postDeployCustomScript.containerType !== "custom" && ( */}
                            <Box
                                title={"Run When*"}
                                subtitle={"Choose when to run the post-deploy script"}
                                titleStyle={boxTitleStyle}
                                subTitleStyle={boxSubtitleStyle}
                                style={{ ...boxStyle }}
                            >
                                <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                                    {/* Trigger Mode */}
                                    <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                        <label style={{
                                            display: "block",
                                            marginBottom: "8px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#1f1f1f"
                                        }}>
                                            Trigger Mode
                                        </label>
                                        <Select
                                            className="customSelectDataSource"
                                            value={postDeployCustomScript.triggerMode}
                                            onChange={(value) => {
                                                setPostDeployCustomScript({ ...postDeployCustomScript, triggerMode: value });
                                                form.setFieldsValue({ triggerMode: value });
                                            }}
                                            style={{ width: "100%" }}
                                            data-testid="workflow-tool-post-deploy-migration-script-trigger-mode-select"
                                        >
                                            <Option value='immediate'>Immediately after deploy</Option>
                                            <Option value='ready'>After rollout completes (all new Pods Ready)</Option>
                                            <Option value='delay'>After a delay</Option>
                                            <Option value='manual'>Manual trigger</Option>
                                        </Select>
                                    </div>

                                    {/* Delay field - shown when delay mode */}
                                    {postDeployCustomScript.triggerMode === 'delay' && (
                                        <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                            <label style={{
                                                display: "block",
                                                marginBottom: "8px",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "#1f1f1f"
                                            }}>
                                                Delay (seconds)*
                                            </label>
                                            <Form.Item
                                                name="delaySeconds"
                                                rules={[
                                                    {
                                                        required: postDeployCustomScript.triggerMode === 'delay',    // && postDeployCustomScript.containerType !== 'custom'
                                                        message: 'Please provide delay in seconds.',
                                                    },
                                                    {
                                                        type: 'number',
                                                        min: 0,
                                                        max: 3600,
                                                        message: 'Delay must be between 0 and 3600 seconds.',
                                                    }
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber
                                                    // min={0}
                                                    // max={3600}
                                                    value={postDeployCustomScript.delaySeconds}
                                                    onChange={(value) => {
                                                        setPostDeployCustomScript({ ...postDeployCustomScript, delaySeconds: value });
                                                        form.setFieldsValue({ delaySeconds: value });
                                                    }}
                                                    style={{ width: "100%" }}
                                                    data-testid="workflow-tool-post-deploy-migration-script-delay-seconds-input"
                                                />
                                            </Form.Item>
                                        </div>
                                    )}

                                    {/* Readiness Strategy - shown when ready mode */}
                                    {postDeployCustomScript.triggerMode === 'ready' && (
                                        <>
                                            <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "8px",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "#1f1f1f"
                                                }}>
                                                    Readiness Strategy
                                                </label>
                                                <Select
                                                    className="customSelectDataSource"
                                                    value={postDeployCustomScript.readyStrategy}
                                                    onChange={(value) => {
                                                        setPostDeployCustomScript({ ...postDeployCustomScript, readyStrategy: value });
                                                        form.setFieldsValue({ readyStrategy: value });
                                                    }}
                                                    style={{ width: "100%" }}
                                                    data-testid="workflow-tool-post-deploy-migration-script-ready-strategy-select"
                                                >
                                                    <Option value='k8s'>Kubernetes (default)</Option>
                                                    {/* <Option value='http'>HTTP health check</Option> */}
                                                </Select>
                                            </div>

                                            {/* Health URL - shown when HTTP health check */}
                                            {postDeployCustomScript.readyStrategy === 'http' && (
                                                <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                                    <label style={{
                                                        display: "block",
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "#1f1f1f"
                                                    }}>
                                                        Health URL*
                                                    </label>
                                                    <Form.Item
                                                        name="healthUrl"
                                                        rules={[
                                                            {
                                                                required: postDeployCustomScript.readyStrategy === 'http',   // && postDeployCustomScript.containerType !== 'custom'
                                                                message: 'Please provide health URL.',
                                                            },
                                                            {
                                                                type: 'url',
                                                                message: 'Please provide a valid URL.',
                                                            }
                                                        ]}
                                                        style={{ marginBottom: 0 }}
                                                    >
                                                        <Input
                                                            name="healthUrl"
                                                            value={postDeployCustomScript.healthUrl}
                                                            onChange={(e) => {
                                                                setPostDeployCustomScript({ ...postDeployCustomScript, healthUrl: e.target.value });
                                                                form.setFieldsValue({ healthUrl: e.target.value });
                                                            }}
                                                            placeholder='http://svc.ns.svc:8080/health'
                                                            style={inputStyle}
                                                            data-testid="workflow-tool-post-deploy-migration-script-health-url-input"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            )}

                                            {/* Timeout */}
                                            <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "8px",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "#1f1f1f"
                                                }}>
                                                    Timeout (seconds)*
                                                </label>
                                                <Form.Item
                                                    name="timeoutSeconds"
                                                    rules={[
                                                        {
                                                            required: postDeployCustomScript.triggerMode === 'ready',   // && postDeployCustomScript.containerType !== 'custom'
                                                            message: 'Please provide timeout.',
                                                        },
                                                        {
                                                            type: 'number',
                                                            min: 30,
                                                            max: 3600,
                                                            message: 'Timeout must be between 30 and 3600 seconds.',
                                                        }
                                                    ]}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <InputNumber
                                                        // min={30} 
                                                        // max={3600}
                                                        value={postDeployCustomScript.timeoutSeconds}
                                                        onChange={(value) => {
                                                            setPostDeployCustomScript({ ...postDeployCustomScript, timeoutSeconds: value });
                                                            form.setFieldsValue({ timeoutSeconds: value });
                                                        }}
                                                        style={{ width: "100%" }}
                                                        data-testid="workflow-tool-post-deploy-migration-script-timeout-seconds-input"
                                                    />
                                                </Form.Item>
                                            </div>

                                            {/* Poll Interval */}
                                            <div style={{ marginBottom: "16px", marginLeft: "20px" }}>
                                                <label style={{
                                                    display: "block",
                                                    marginBottom: "8px",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "#1f1f1f"
                                                }}>
                                                    Poll Interval (seconds)*
                                                </label>
                                                <Form.Item
                                                    name="pollSeconds"
                                                    rules={[
                                                        {
                                                            required: postDeployCustomScript.triggerMode === 'ready',   // && postDeployCustomScript.containerType !== 'custom'
                                                            message: 'Please provide poll interval.',
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (value === undefined || value === null || value === '') {
                                                                    return Promise.resolve();
                                                                }
                                                                if (!Number.isInteger(value)) {
                                                                    return Promise.reject(new Error('Poll interval must be a positive integer.'));
                                                                }
                                                                if (value < 1 || value > 60) {
                                                                    return Promise.reject(new Error('Poll interval must be between 1 and 60 seconds.'));
                                                                }
                                                                const timeout = getFieldValue('timeoutSeconds');
                                                                if (timeout && value > timeout) {
                                                                    return Promise.reject(new Error('Poll interval cannot be greater than timeout'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <InputNumber
                                                        // min={1}
                                                        // max={60}
                                                        value={postDeployCustomScript.pollSeconds}
                                                        onChange={(value) => {
                                                            setPostDeployCustomScript({ ...postDeployCustomScript, pollSeconds: value });
                                                            form.setFieldsValue({ pollSeconds: value });
                                                        }}
                                                        style={{ width: "100%" }}
                                                        data-testid="workflow-tool-post-deploy-migration-script-poll-seconds-input"
                                                    />
                                                </Form.Item>
                                            </div>
                                        </>
                                    )}
                                </ContentHolder>
                            </Box>
                            {/* )} */}

                            <div ref={scriptSectionRef} data-testid="workflow-tool-post-deploy-migration-script-script-input">
                                <Box
                                    title={"Script*"}
                                    subtitle={error && <p className="isoHelperText labels">Post-Deploy script can't be empty</p>}
                                    titleStyle={boxTitleStyle}
                                    subTitleStyle={boxSubtitleStyle}
                                    style={{ ...boxStyle, marginBottom: "150px" }}
                                >
                                    <Form.Item
                                        name="script"
                                        hidden
                                        rules={[
                                            {
                                                validator: (_, value) => {
                                                    if (value && value.trim() !== "") {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Please provide a script.'));
                                                }
                                            }
                                        ]}
                                    >
                                        <AntInput />
                                    </Form.Item>
                                    <CodeViewGeneral
                                        data={postDeployCustomScript.script}
                                        setData={(value) => {
                                            log("Script changed in editor to:", value?.substring(0, 50));
                                            setPostDeployCustomScript((prev) => ({ ...prev, script: value }));
                                            form.setFieldsValue({ script: value });
                                            setHasUserEdited(true); // Mark that user has edited
                                            setError(!value || value.trim() === "");
                                        }}
                                        setError={setError}
                                        height="calc(100vh - 300px)"
                                        minHeight="370px"
                                        type="script"
                                        readOnly={currentWorkflowData.fromPipeline ? true : false}
                                        placeholder="#!/bin/bash&#10;# Enter your migration or custom script here&#10;# Example: python manage.py migrate"
                                    />
                                </Box>
                            </div>
                        </Form>
                    </StickerWidgetWrapper>
                </div>
            </Col>

            {/* Show action buttons only when drawer is editable */}
            {!currentWorkflowData?.fromPipeline && (
                <CreateTaskFooter
                    buttonContent={"Custom Script"}
                    givenButtonFunction1={handleSaveDetails}
                    givenButtonFunction2={handelCancel}
                    openDrawer={openDrawer}
                    saveButtonTestId="workflow-tool-post-deploy-migration-script-save-button"
                    cancelButtonTestId="workflow-tool-post-deploy-migration-script-cancel-button"
                />
            )}

        </LayoutWrapper>
    );
};